import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCaretLeft, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { SquiggleItem } from '../types/types';
import './AliasItem.css';

function AliasItem({
    item,
    isSelected,
    addAlias,
    removeAlias,
    setIgnoreCanonicalName,
    setCaseSensitiveNames,
    back
} : {
  item: SquiggleItem,
  isSelected: boolean,
  addAlias: (itemId: string, alias: string) => void,
  removeAlias: (itemId: string, index: number) => void,
  setIgnoreCanonicalName: (item: SquiggleItem, ignore: boolean) => void,
  setCaseSensitiveNames: (item: SquiggleItem, caseSensitive: boolean) => void,
  back: () => void
}) {
  const [showAddAliasRow, setShowAddAliasRow] = useState<boolean>(false);
  const [newAlias, setNewAlias] = useState<string>("");

  useEffect(() => {
    if (!isSelected) {
      return;
    }

    const listener = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !e.ctrlKey && !e.metaKey) {
        e.stopPropagation();
        e.preventDefault();
        back();
        return;
      }
    };

    window.addEventListener('keydown', listener);
    return () => window.removeEventListener('keydown', listener);
  }, [isSelected, back]);
  
  return <>
    <div className="formrow"><span className="name">{item.name}</span></div>
    <div className="settings">
      { item.type !== "system" && (<div className="formrow">
        <div className="segmentcontrol">
          <div className="segmentlabel">Ignore canonical name</div>
          <div className="segmented">
            <button
              className={`segment ${!item.ignoreCanonicalName ? 'active' : ''}`}
              type="button"
              onClick={() => setIgnoreCanonicalName(item, false)}
            >
              No
            </button>
            <button
              className={`segment ${item.ignoreCanonicalName ? 'active warning' : ''}`}
              type="button"
              onClick={() => setIgnoreCanonicalName(item, true)}
            >
              Yes
            </button>

          </div>
        </div>
      </div>)
      }
      { item.type !== "system" && (<div className="formrow">
        <div className="segmentcontrol">
          <div className="segmentlabel">Require exact letter case</div>
          <div className="segmented">
            <button
              className={`segment ${!item.caseSensitiveNames ? 'active' : ''}`}
              type="button"
              onClick={() => setCaseSensitiveNames(item, false)}
            >
              No
            </button>
            <button
              className={`segment ${item.caseSensitiveNames ? 'active warning' : ''}`}
              type="button"
              onClick={() => setCaseSensitiveNames(item, true)}
            >
              Yes
            </button>
          </div>
        </div>
      </div>)
      }
    </div>
    <div className="aliases">
      <div className="formrow"><div className="aliasheading">Name aliases for wiki-like linking:</div></div>
      { item.type === "system" ?
        (<div className="formrow"><div className="aliasheading sysmsg" style={{ paddingTop: '0.5em' }}>You cannot create aliases for system information items.</div></div>) :
        (<div className="formrow">
          <ul>
            { item.aliases.map((alias, index) =>
                <li key={index} data-id={index}>
                  <span className="removeAlias" onClick={() => removeAlias(item.id, index)}><FontAwesomeIcon icon={faXmark as IconProp} /></span>
                  {alias}
                </li>
              )
            }
          </ul>
        </div>)
      }
    </div>
    <div className="formrow grow"></div>
    {
      showAddAliasRow && <div className="formrow">
        <input className="grow newalias" type="text" autoFocus value={newAlias} onChange={(e) => setNewAlias(e.target.value)} onKeyDown={(e) => e.stopPropagation()}></input>
        <button onClick={() => { addAlias(item.id, newAlias); setNewAlias(""); setShowAddAliasRow(false); }}>Add alias</button>
      </div>
    }
    <div className="buttonrow reverse">
      <div className="buttoncontainer">
        { !showAddAliasRow && <button className={item.type === 'system' ? 'disabled' : ''} onClick={() => item.type !== 'system' && setShowAddAliasRow(true)}>Add alias</button> }
      </div>
      <div className="buttoncontainer grow">
        <button title="Back [Esc]" onClick={back}><FontAwesomeIcon icon={faCaretLeft as IconProp}></FontAwesomeIcon>Back</button>
      </div>
    </div>
  </>;
}

export default AliasItem;